import { forwardRef } from 'react'

const variantClasses = {
    primary: 'bg-sky-600 text-white hover:bg-sky-700 border-sky-600',
    secondary: 'bg-white text-slate-700 hover:bg-slate-50 border-slate-200',
    danger: 'bg-rose-600 text-white hover:bg-rose-700 border-rose-600',
    ghost: 'bg-transparent text-slate-700 hover:bg-slate-100 border-transparent',
}

export const Button = forwardRef(function Button(
    { variant = 'primary', type = 'button', disabled = false, className = '', children, ...props },
    ref
) {
    const baseClasses = 'inline-flex items-center justify-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50'
    const variantClass = variantClasses[variant] || variantClasses.primary

    return (
        <button
            ref={ref}
            type={type}
            disabled={disabled}
            className={`${baseClasses} ${variantClass} ${className}`}
            {...props}
        >
            {children}
        </button>
    )
})

export default Button
